/*
Author: Shivakumar
Date: 1/4/2020
Issue Description: Need validation on the First Payroll on Paylief with Incorporation date and Legal Entity activation date
search: PL_2795
*/
<template>
  <div>
    <toast-message
      :message="errmsg"
      type="error"
      :isToastEnable="toast"
      @close="(val) => toast = val"
    />
    <div class="permission-alert-msg" v-show="!(ifTeamleaderPermission)">
      You have only view permission.
    </div>
    <div class="payroll-cycle" :disabled="!(ifTeamleaderPermission)">
      <tl-select
        labelText="name"
        label="Pay Frequency *"
        name="payfrequency"
        v-model="formData.payFrequency"
        :options="payFrequencyList"
        @change="(val)=>{formData.payFrequency=val.id}"
        :disabled="true"
        data-vv-as="pay frequency"
        v-validate="{required: true}"
        :classname="errors.has('payfrequency')"
        :errormsg="errors.first('payfrequency')"
      />
      <div class="input-label margintop-24">First PayRoll On Paylief</div>
      <!-- PL_2795 -->
      <date-picker
        class="datepicker"
        :initialView="'month'"
        :formatDate="'MMMM-yyyy'"
        :maximumView="'year'"
        :minimumView="'month'"
        v-model="formData.firstPayroll"
        :disabled="formData.isPayrollDoneForLE"
        @datevalue="(val)=>{formData.firstPayroll=val;getFormattedMonth(val)}"
        :dates-disabled="{to:new Date(leIncorporationDate), from: new Date()}"
      />
      <!-- PL_2795 -->
      <!-- :dates-disabled="{to:new Date(leIncorporationDate), from: new Date(new Date().setDate(new Date().getDate()-1))}" -->
      <div class="input-label margintop-24">Attendance Cut Off Cycle *</div>
      <div class="row marginright15 margintop8">
        <div class="col-1">
          <tl-select
            :options="startDateOptions"
            class="customwidth"
            v-model="formData.attendanceStart"
            placeholder="From"
            @change="changeDate($event)"
            name="fromCutOff"
            data-vv-as="from"
            v-validate="{required: true}"
            :classname="errors.has('fromCutOff')"
            :errormsg="errors.first('fromCutOff')"
          ></tl-select>
        </div>
        <div class="col-1 marginleft-56">
          <tl-select
            class="customwidth"
            placeholder="To"
            :options="startDateOptions"
            v-model="formData.attendanceEnd"
            :disabled="true"
            @change="(val)=>formData.attendanceEnd = val"
            name="toCutOff"
            data-vv-as="to"
            v-validate="{required: true}"
            :classname="errors.has('toCutOff')"
            :errormsg="errors.first('toCutOff')"
          ></tl-select>
        </div>
      </div>
      <div class="input-label margintop-32">Employee Joining Cut Off Date Applicable</div>
      <div class="row margintop-16">
        <tl-radio
        name="joiningCutoff"
        class="col-2"
        label="Yes"
        id="joiningCutoff1"
        :value="true"
        v-model="formData.isJoiningCutoffDate"
        @change="onJoiningCutoffDateChange(formData.isJoiningCutoffDate)"
        />
        <tl-radio
        name="joiningCutoff"
        class="col-1"
        label="No"
        id="joiningCutoff2"
        :value="false"
        v-model="formData.isJoiningCutoffDate"
        @change="onJoiningCutoffDateChange(formData.isJoiningCutoffDate)"
        />
      </div>
      <tl-select
        v-show="formData.isJoiningCutoffDate"
        labelText="name"
        label="Employee joining cutoff date *"
        class="margintop-24"
        name="cutoffDate"
        v-model="formData.cutoffDate"
        :options="startDateOptions"
        @change="(val)=>{formData.cutoffDate=val}"
        data-vv-as="cut off date"
        v-validate="{required: formData.isJoiningCutoffDate}"
        :classname="errors.has('cutoffDate')"
        :errormsg="errors.first('cutoffDate')"
      />
    </div>

    <tick-animation v-if="showSuccessMsg"></tick-animation>

    <bottom-action-container>
      <btn-skip @navClicked="skip" @click="skip"></btn-skip>
      <template slot="end">
        <btn-grp>
          <btn text="Previous" type="secondary" @click="previous" />
          <!-- <btn text="Next" type="primary" @click="save" v-show="!ifAnchor && ifTeamleaderPermission"/> -->
          <btn text="Next" type="primary" @click="save" v-show="(ifTeamleaderPermission || ifSuperAdmin || ifAnchor)"/>
        </btn-grp>
      </template>
    </bottom-action-container>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import * as constants from "@/apis/constants.js";

export default {
  name: "PayrollCycle",

  computed: {
    leId() {
      if (this.$route.params.entity_index) {
        return this.getLegalEntityId(this.$route.params.entity_index);
      }
      return this.getLegalEntityId(0);
    },
    orgId() {
      return this.$store.getters["onboard/getOrgId"];
    },
    ...mapState({
      payrollCycleData: state =>
        state.onboard.settings.payroll_cycle.entityWiseData[this.leId],
      leData: state => state.onboard.legal_entities.data
    }),
    ...mapGetters({
      getLegalEntityId: "onboard/legal_entities/legal_entity_ID"
    }),
    ifAnchor() {
      return localStorage.getItem("userRole") == "ANCHOR" ? true : false;
    },
    ...mapState("onboard/organization", {
      orgIds: state => state.id,
    }),
    ifTeamleaderPermission() {
      if(this.role === 'ADMIN') {
        return true;
      } else if(this.role === 'TEAMLEADER') {
        if(this.payrollPreferencesValue) {
          return true;
        } 
        else {
          return false;
        }
      } else {
        return false
      }

      // if(this.role === 'TEAMLEADER' || this.role === 'ADMIN') {
      //   if(this.payrollPreferencesValue) {
      //   return true;
      //   } else {
      //     return false;
      //   }
      // }
      // else {
      //  return true
      // }
    },
    ifSuperAdmin() {
      return localStorage.getItem("userRole") == "SUPERADMIN" ? true : false;
    },
  },
  mounted() {
    this.setConstantsData();
    this.resetForm();
    this.getAllDates();
    this.fetchAll();
    this.setFirstRunOnPayliefDateValidations();
    this.getOrgLeIdList();
  },
  activated() {
    this.setConstantsData();
    this.resetForm();
    this.getAllDates();
    this.fetchAll();
    this.setFirstRunOnPayliefDateValidations();
    this.getOrgLeIdList();
  },
  data() {
    return {
      month: new Date(),
      leIncorporationDate: null,
      leCreatedDate: null,
      payFrequencyList: [],
      formData: {
        payFrequency: "",
        firstPayroll: "",
        attendanceEnd: null,
        attendanceStart: null,
        isJoiningCutoffDate: null,
        cutoffDate: null,
        isPayrollDoneForLE: false //PL_2795
      },
      errmsg: "",
      toast: false,
      startDateOptions: [],
      showSuccessMsg: false,
      payrollPreferencesValue: false,
      role: ""
    };
  },
  methods: {
    ...mapActions({
      act_fetchAll: "onboard/settings/payroll_cycle/fetchAll",
      act_create: "onboard/settings/payroll_cycle/create",
      act_update: "onboard/settings/payroll_cycle/update",
      act_changeEditMode: "onboard/settings/payroll_cycle/changeEditMode"
    }),

    ...mapActions({
      getOrgLeList: "onboard/organization/getOrgLeIdList",
    }),

    /** Logic to set the 'First PayRoll On Paylief' feild value */
    setFirstRunOnPayliefDateValidations() {
      try {
        this.leIncorporationDate = this.leData[this.$route.params.entity_index]
          .incorporationDate
          ? this.leData[this.$route.params.entity_index].incorporationDate
          : null;
        this.leCreatedDate = this.leData[this.$route.params.entity_index]
          .created_at
          ? this.leData[this.$route.params.entity_index].created_at
          : null; //PL_2795
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    /** To set the value of dropdowns from the constants file */
    setConstantsData() {
      try {
        this.payFrequencyList =
          constants.PayrollSettingsConstants.payFrequencyList;
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    getFormattedMonth(val) {},
    skip() {
      this.$emit("stepNum", 1);
    },
    /** Navigation to previous screen */
    previous() {
      this.$router.push(
        `/onboarding/entity/${this.$route.params.entity_index}/misc`
      );
    },
    /** On date drop down change */
    changeDate(event) {
      try {
        this.formData.attendanceStart = event;
        this.formData.attendanceStart = this.formData.attendanceStart;
        this.formData.attendanceEnd = event !== 1 ? event - 1 : 31;
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /** Function to display the days value in drop down */
    getAllDates() {
      try {
        for (let i = 1; i <= 31; i++) {
          this.startDateOptions.push(i);
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /** Function to reset the form data */
    resetForm() {
      try {
        this.formData = {
          payFrequency: "",
          firstPayroll: "",
          attendanceEnd: null,
          attendanceStart: null,
          isJoiningCutoffDate: null,
          cutoffDate: null
        };
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    onJoiningCutoffDateChange(cutoffDateFlag) {
      if (cutoffDateFlag == "true") {
        this.formData.isJoiningCutoffDate = true;
      } else {
        this.formData.isJoiningCutoffDate = false;
      }
    },
    /** Function to fetch the data from server and populate the data in form */
    async fetchAll() {
      try {
        let res = await this.act_fetchAll(this.leId);
        let payrollSettingsData = res.data.payload.data;
        if (payrollSettingsData) {
          if (this.leId == payrollSettingsData.le_id) {
             this.formData.payFrequency = payrollSettingsData.payFrequency;
             this.formData.firstPayroll = payrollSettingsData.firstPayroll;
             this.formData.isPayrollDoneForLE = payrollSettingsData.isPayrollDoneForLE; //PL_2795
             this.formData.attendanceEnd = payrollSettingsData.attendanceEnd
                ? payrollSettingsData.attendanceEnd : null;
             this.formData.attendanceStart = payrollSettingsData.attendanceStart
                ? payrollSettingsData.attendanceStart : null;
            this.formData.isJoiningCutoffDate = payrollSettingsData.isJoiningCutoffDate
                ? true: false;
            this.formData.cutoffDate = payrollSettingsData.cutoffDate
                ? payrollSettingsData.cutoffDate : null;
          }
          for (var j = 0; j < this.payFrequencyList.length; j++) {
            if (this.formData.payFrequency == this.payFrequencyList[j].id) {
              this.payFrequency = this.payFrequencyList[j].name;
            }
          }
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /** Function to submit the form data to server */
    async performAction() {
      try {
        this.apirequestObj = {
          payFrequency: this.formData.payFrequency,
          firstPayroll: this.formData.firstPayroll
            ? this.formData.firstPayroll
            : null,
          attendanceStart: this.formData.attendanceStart
            ? Number(this.formData.attendanceStart)
            : 0,
          attendanceEnd: this.formData.attendanceEnd
            ? Number(this.formData.attendanceEnd)
            : 0,
          selected_paygroup_id: null,
          isJoiningCutoffDate: this.formData.isJoiningCutoffDate
            ? true : false,
          cutoffDate: (this.formData.cutoffDate && this.formData.isJoiningCutoffDate)
            ? this.formData.cutoffDate : null,
        };
        try {
          this.$root._data.isSaving = true;
          let res = await this.act_create({
            data: {
              le_id: this.leId,
              ...this.apirequestObj
            }
          });
          if (res.data.status) {
            this.changeMode(res.data.payload);
          }
          setTimeout(() => {
            this.$root._data.isSaving = false;
            this.showSuccessMsg = true;
            this.hideSuccessMsg();
          }, 500);
        } catch (err) {
          this.$root._data.isSaving = false;
          this.toast = true;
          this.errmsg = err;
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /** To change/update store data based on requirement */
    async changeMode(payload) {
      try {
        await this.act_changeEditMode(payload);
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /* function to hide success message and navigate to next screen */
    hideSuccessMsg() {
      setTimeout(() => {
        this.showSuccessMsg = false;
        this.$emit("stepNum", 1);
      }, 1000);
    },
    /** Function to validate the form data */
    async save() {
      try {
        if(this.ifAnchor || this.ifSuperAdmin) {
          this.nextPage();
        } else {
        this.$validator.validateAll().then(result => {
          if (result) {
            this.performAction();
            //this.$emit('stepNum',1);
          } else {
            /** Logic to focus the screen on error feild when submitted */
            this.$el
              .querySelector(
                '[data-vv-name="' + this.$validator.errors.items[0].field + '"]'
              )
              .focus();
            this.$el
              .querySelector(
                '[data-vv-name="' + this.$validator.errors.items[0].field + '"]'
              )
              .scrollIntoView({
                behavior: "smooth",
                block: "center",
                inline: "center"
              });
          }
        });
       }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /* function is use to move next page as user role is anchor */
    nextPage() {
      this.$emit("stepNum", 1);
    },

    async getOrgLeIdList() {
      const org = this.orgIds;
      const le = this.leId;
      //console.log("Org:",org);
      //console.log("Le ID",le);
      let bodyParams = {};
      let  data = await this.getOrgLeList({
        data: {
            ...bodyParams
        }
      });
      this.role = data.data.user.userRole;
      this.payrollPreferencesValue = data.data.user.permissions.payroll_preferences ? true : false;
      //console.log("PL-3406",data);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/scss/components/margins.scss";
.payroll-cycle {
  margin-bottom: 150px;
  width: 100%;
}
.errorr {
  border: 1px solid #e01717;
}
.errorMessage {
  color: #e01717;
}
.marginright15 {
  margin-left: -15px;
}
.customwidth {
  width: 157px;
  height: 35px;
  padding-right:30px;
}
.margintop8 {
  margin-top: -8px;
}

.permission-alert-msg {
  background-color: #f8d7da;
  padding: 1rem 1rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  font-weight: 600;
  color: #842029;
  border: 1px solid transparent;
  border-radius: .25rem;
  border-color: #f5c2c7;
}
</style>
